import { render, staticRenderFns } from "./IcelinkTest.vue?vue&type=template&id=42720694&scoped=true&"
import script from "./IcelinkTest.vue?vue&type=script&lang=js&"
export * from "./IcelinkTest.vue?vue&type=script&lang=js&"
import style0 from "./IcelinkTest.vue?vue&type=style&index=0&id=42720694&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42720694",
  null
  
)

export default component.exports